import { ref, computed } from 'vue'
import * as skillsApi from '../api/skills.js'

export function useSkills() {
  const skills = ref([])
  const loading = ref(false)
  const error = ref(null)

  const userSkills = computed(() => skills.value.filter(s => !s.shared))
  // Project-wide skills authored on this project (editable by their creator).
  const sharedSkills = computed(() => skills.value.filter(s => s.shared && !s.global))
  // Built-ins shipped with RPilot: visible on every project, read-only here.
  const builtInSkills = computed(() => skills.value.filter(s => s.global))

  async function refresh(query, tag) {
    loading.value = true
    error.value = null
    try {
      skills.value = await skillsApi.listSkills({ query, tag })
    } catch (e) {
      error.value = e.message
    } finally {
      loading.value = false
    }
  }

  async function load(name, shared = false) {
    try {
      return await skillsApi.getSkill(name, shared)
    } catch (e) {
      error.value = e.message
      return null
    }
  }

  async function save(request) {
    try {
      await skillsApi.saveSkill(request)
      await refresh()
      return true
    } catch (e) {
      error.value = e.message
      return false
    }
  }

  async function remove(name, shared = false) {
    try {
      await skillsApi.deleteSkill(name, shared)
      await refresh()
      return true
    } catch (e) {
      error.value = e.message
      return false
    }
  }

  return { skills, userSkills, sharedSkills, builtInSkills, loading, error, refresh, load, save, remove }
}
